import { UNLIMITED_QUOTA_SENTINEL } from '@/lib/quota/deriveQuotaPressure';

/** Finite plan caps show "N of M templates created". Unlimited caps stay silent. */
export function shouldShowBrandKitsCount(
  max: number | null | undefined,
): max is number {
  return typeof max === 'number' && max > 0 && max < UNLIMITED_QUOTA_SENTINEL;
}
